export const CONTENT_TYPES = {
  APPLICATION_JSON: 'application/json',
  TEXT_PLAIN: 'text/pain'
};
